/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Photo Gallery',
  definitions: {
    '16': {
      viewBox: '0 0 16 16',
      path: (
        <>
          <path
            d="M9 6.839a1.901 1.901 0 1 0 0 3.803 1.901 1.901 0 1 0 0-3.803zm-.802 1.902a.801.801 0 1 1 1.603 0 .801.801 0 1 1-1.603 0zM3 5.047a1.55 1.55 0 0 0-1.55 1.55v7A1.55 1.55 0 0 0 3 15.147h10a1.55 1.55 0 0 0 1.55-1.55v-7A1.55 1.55 0 0 0 13 5.047H3zm-.45 1.55a.45.45 0 0 1 .45-.45h10a.45.45 0 0 1 .45.45v4.95l-.906-.906a1.05 1.05 0 0 0-1.485 0l-1.991 1.991L5.04 8.603a1.05 1.05 0 0 0-1.485 0L2.55 9.608V6.597zm6.661 7.45H13a.45.45 0 0 0 .45-.45v-.495l-1.648-1.648-2.591 2.593zm-4.914-4.63l4.63 4.63H3a.45.45 0 0 1-.45-.45v-2.433l1.747-1.747z"
            fillRule="evenodd"
            fill="currentColor"
          />
          <path
            d="M13.455 4.053A1.55 1.55 0 0 0 11.97 2.95H4.03a1.55 1.55 0 0 0-1.485 1.103h10.91zm-1.344-2.097A1.55 1.55 0 0 0 10.626.853H5.374a1.55 1.55 0 0 0-1.485 1.103h8.222z"
            fill="currentColor"
          />
        </>
      ),
    },
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            d="M13.823 9.324c-1.338 0-2.423 1.085-2.423 2.423s1.085 2.423 2.423 2.423 2.423-1.085 2.423-2.423-1.085-2.423-2.423-2.423zM12.6 11.748c0-.676.548-1.223 1.223-1.223s1.223.548 1.223 1.223-.548 1.223-1.223 1.223-1.223-.548-1.223-1.223zM4.099 6.546a2.1 2.1 0 0 0-2.1 2.1v11.102a2.1 2.1 0 0 0 2.1 2.1h15.803a2.1 2.1 0 0 0 2.1-2.1V8.646a2.1 2.1 0 0 0-2.1-2.1H4.099zm-.9 2.1a.9.9 0 0 1 .9-.9h15.803a.9.9 0 0 1 .9.9v7.308l-1.89-1.89a1.35 1.35 0 0 0-1.909 0l-3.329 3.329-6.521-6.521a1.35 1.35 0 0 0-1.909 0l-2.045 2.045v-4.27zM13.674 19.09l-7.37-7.37a.15.15 0 0 0-.212 0l-2.893 2.893v5.135a.9.9 0 0 0 .9.9h15.803a.9.9 0 0 0 .9-.9v-2.097l-2.739-2.739a.15.15 0 0 0-.212 0l-4.176 4.178z"
            fillRule="evenodd"
            fill="currentColor"
          />
          <path
            d="M19.909 5.549H4.091A2.1 2.1 0 0 1 5.988 4.35h12.023a2.1 2.1 0 0 1 1.897 1.199zm-2.053-2.196a2.1 2.1 0 0 0-1.898-1.201H8.043a2.1 2.1 0 0 0-1.898 1.201h11.711z"
            fill="currentColor"
          />
        </>
      ),
    },
    '32': {
      viewBox: '0 0 32 32',
      path: (
        <>
          <path
            d="M18.145 11.994a3.11 3.11 0 0 0-3.107 3.107 3.11 3.11 0 0 0 3.107 3.107 3.11 3.11 0 0 0 3.107-3.107 3.11 3.11 0 0 0-3.107-3.107zm-1.907 3.107a1.91 1.91 0 0 1 1.907-1.907 1.91 1.91 0 0 1 1.907 1.907 1.91 1.91 0 0 1-1.907 1.907 1.91 1.91 0 0 1-1.907-1.907zM4.63 8.15a2.1 2.1 0 0 0-2.1 2.1v16.305a2.1 2.1 0 0 0 2.1 2.1h22.74a2.1 2.1 0 0 0 2.1-2.1V10.25a2.1 2.1 0 0 0-2.1-2.1H4.63zm-.9 2.1a.9.9 0 0 1 .9-.9h22.74a.9.9 0 0 1 .9.9v11.46l-2.701-2.701a2 2 0 0 0-2.828 0l-4.449 4.449-8.819-8.819a2 2 0 0 0-2.828 0L3.73 17.552V10.25zm14.561 14.905l-9.668-9.668a.8.8 0 0 0-1.131 0L3.73 19.249v7.306a.9.9 0 0 0 .9.9h22.74a.9.9 0 0 0 .9-.9v-3.148l-3.55-3.55a.8.8 0 0 0-1.131 0l-5.297 5.299z"
            fillRule="evenodd"
            fill="currentColor"
          />
          <path
            d="M26.682 6.946a2.1 2.1 0 0 0-1.898-1.201H7.217a2.1 2.1 0 0 0-1.898 1.201h21.363zm-2.815-2.403H8.133a2.1 2.1 0 0 1 1.897-1.198h11.94a2.1 2.1 0 0 1 1.897 1.198z"
            fill="currentColor"
          />
        </>
      ),
    },
    '48': {
      viewBox: '0 0 48 48',
      path: (
        <>
          <path
            d="M27.163 18.06a3.752 3.752 0 1 0 0 7.503 3.752 3.752 0 1 0 0-7.503zm-2.501 3.751a2.502 2.502 0 1 1 5.003 0 2.502 2.502 0 1 1-5.003 0zM6.525 12.392c-1.174 0-2.125.951-2.125 2.125V39.98c0 1.174.951 2.125 2.125 2.125h34.95c1.174 0 2.125-.951 2.125-2.125V14.517c0-1.174-.951-2.125-2.125-2.125H6.525zm-.875 2.125c0-.483.392-.875.875-.875h34.95c.483 0 .875.392.875.875v17.884l-4.471-4.471c-1.025-1.025-2.687-1.025-3.712 0l-6.789 6.789-13.232-13.232c-1.025-1.025-2.687-1.025-3.712 0L5.65 26.271V14.517zm21.726 21.967L13.262 22.371c-.537-.537-1.407-.537-1.944 0L5.65 28.039V39.98c0 .483.392.875.875.875h34.95c.483 0 .875-.392.875-.875v-5.811l-5.355-5.355c-.537-.537-1.407-.537-1.945 0l-7.675 7.671z"
            fillRule="evenodd"
            fill="currentColor"
          />
          <path
            d="M39.572 10.392H8.379c.334-.736 1.075-1.247 1.936-1.247h27.322c.86 0 1.602.511 1.936 1.247zm-4.146-3.247c-.333-.737-1.075-1.25-1.937-1.25H14.461c-.862 0-1.604.513-1.937 1.25h22.902z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
